import {
  convertServerDateToClientDate,
  formatServerDate,
} from '../../../utils';
import {
  getCornerDates,
  /* TODO: Эта группа TODO будем искать их по ключевому слову СПАСИТЕ ниже описание
  getFlexEndDatesFromNights,
  getShiftFromFlexDates,
  isSmallShift,
  FlexDates,
  */
} from '../components/DatePicker/components/Calendar/utils';

import type { SearchLand } from '@lt/api/dist/methods/search/types';
import type {
  getReferencesCountriesResponse,
  GroupName,
} from '@lt/api/dist/methods/references/types';
import type { SearchType } from '../types';
import type { RequiredValues } from '../context';
import type { DatePickerState } from '../components/DatePicker';
import type { DateCell } from '../components/DatePicker/types';
import type { TripsterLand } from '../hooks/useSearchLand';

import {
  SEARCH_TYPE_NAMES,
  DEFAULT_DEPARTURE_COUNTRY_ISO2,
} from '../constants';
import { differenceInDays } from 'date-fns';

export const buildLandParams = ({
  departure,
  destination,
  datepicker,
  tourists,
  host,
  searchType,
}: RequiredValues & {
  host?: string;
  searchType: SearchType;
}): SearchLand | TripsterLand => {
  if (searchType === SEARCH_TYPE_NAMES.TRIP) {
    return {
      redirectUrl: destination['url'].replace(
        'experience.tripster.ru',
        'promo.level.travel/excursions#'
      ),
      searchType,
    };
  }

  return {
    ...destinationParams(destination),
    from_city:
      searchType === SEARCH_TYPE_NAMES.PACKAGE ? departure.value : 'any',
    from_country: departure
      ? departure.iso2 || DEFAULT_DEPARTURE_COUNTRY_ISO2
      : DEFAULT_DEPARTURE_COUNTRY_ISO2,
    adults: tourists.adults,
    kids: tourists.kids.length,
    kids_ages: tourists.kids.join(','),
    ...datesParams(datepicker),
    host,
    search_type: searchType,
  };
};

const destinationParams = ({
  groupName,
  value,
  iso2,
  country,
}: Destination): DestinationParams => {
  switch (groupName) {
    case 'hotels':
      return {
        hotel_ids: value,
        to_country: iso2,
      };
    case 'metaregions':
    case 'allMetaregions':
      return {
        to_metaregion: value,
      };
    case 'countries':
    case 'popularCountries':
    case 'allCountries':
      return {
        to_country: iso2,
      };
    case 'popularDirections':
      return {
        to_city: value,
        to_country: country?.iso2,
      };
    default:
      return {
        to_city: value,
        to_country: iso2,
      };
  }
};

const getFormattedCornerDates = (dateCell: DateCell, shift: number) => {
  const dates = getCornerDates({
    date: dateCell.date,
    shift,
  });

  return {
    from: formatServerDate(dates.from),
    to: formatServerDate(dates.to),
  };
};

const flexStartDates = (dateCell: DateCell, shift: number) => {
  const startDates = getFormattedCornerDates(dateCell, shift);

  return {
    start_date_from: startDates.from,
    start_date_till: startDates.to,
  };
};

const flexEndDates = (dateCell: DateCell, shift: number) => {
  const endDates = getFormattedCornerDates(dateCell, shift);

  return {
    end_date_from: endDates.from,
    end_date_till: endDates.to,
  };
};

/* TODO: Эта группа TODO будем искать их по ключевому слову СПАСИТЕ
const serverFlexEndDates = (flexEndDates: FlexDates) => {
  const { from, to, primary } = flexEndDates;

  return {
    end_date_from: formatServerDate(from),
    end_date_till: formatServerDate(to),
    end_date_primary: convertServerDateToClientDate(primary),
  };
};*/

const datesParams = ({
  left,
  right,
  startDatePreset,
  nightsPreset,
  nights,
  shift,
}: DatePickerState) => {
  const startDatePrimary = convertServerDateToClientDate(left.date);

  if (right.date && left.date) {
    const nights = differenceInDays(right.date, left.date);
    return {
      start_date: startDatePrimary,
      nights: Number(nights),
      flex_dates: shift,
    };
  }

  /**
   * Все что ниже в этой функции непонятно от слова СОВСЕМ
   */
  const startDates = flexStartDates(left, shift);
  if (right.date) {
    return {
      ...flexStartDates(left, shift),
      ...flexEndDates(right, shift),
      start_date_primary: startDatePrimary,
      end_date_primary: convertServerDateToClientDate(right.date),
    };
  }

  /* TODO: Эта группа TODO будем искать их по ключевому слову СПАСИТЕ ниже описание
   * Если через пол года, год вы увидете это коммент, то смело выпиливайте эту часть кода и все связанные функции
   * Тут с гибкими датами завязано пробовал понять, что там, но чет вообще даже рядом не пойму
  if (left.date && nights) {
    const flexEndDates = getFlexEndDatesFromNights(left, nights);

    if (flexEndDates.primary) {
      const endShift = getShiftFromFlexDates(flexEndDates as FlexDates);

      const isSmallStartShift = isSmallShift(left.shift);
      const isSmallEndShift = isSmallShift(endShift);

      if (isSmallStartShift && isSmallEndShift) {
        return {
          ...startDates,
          ...serverFlexEndDates(flexEndDates as FlexDates),
          start_date_primary: startDatePrimary,
        };
      }
    }
  }*/

  const start = startDatePreset
    ? { start_date_preset: startDatePreset.name }
    : startDates;

  // нет возможности описать четкий тип, но если доходит до nights то он точно не пустой
  // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
  const end = nightsPreset
    ? { nights_preset: nightsPreset.name }
    : { nights: nights! };

  return {
    ...start,
    ...end,
  };
};

type Destination = {
  groupName: GroupName;
  value: number | string;
  iso2?: string;
  country?: getReferencesCountriesResponse;
};

type DestinationParams = Pick<
  SearchLand,
  'hotel_ids' | 'to_country' | 'to_metaregion' | 'to_city'
>;
